export const letterSpacing = {
    s: '0.02rem', // 20
    m: '0.036rem', // 36
    l: '0.047rem', // 47
    xl: '0.076rem', // 76
    xxl: '0.1rem', // 100
    '3xl': '0.1rem', // 1.6px
    '4xl': '0.372rem', // 5.952px
};
export const lineHeight = {
    xs: '1.5625',
    s: '1.5825',
    m: '1.6',
    l: '1.625',
    xl: '1.666',
};
// FIXME: This not consistent with zurich CI. Range 4xl - 6xl is too big. Also Redefine Typography sizes
export const size = {
    xxs: '0.625rem', // 10px
    xs: '0.75rem', // 12px
    s: '0.875rem', // 14px h6 bold
    m: '1rem', // 16px
    l: '1.25rem', // 20px h5, subtitle
    xl: '1.5rem', // 24px h4
    xxl: '1.625rem', // 26px h3
    '3xl': '2rem', // 32px
    '3xl-mobile': '1.375rem', // 22px
    '4xl': '3rem', // 48px
    '4xl-mobile': '2.25rem', // 36px
    '5xl': '3.75rem', // 60px
    '6xl': '4.5rem', // 72px
};
export const weight = {
    light: 300,
    regular: 400,
    medium: 500,
    bold: 600,
};
